<template>
    <div>
        <div class="addLogo" v-show="isShowTop" :style="styleTop"><img class="logoImg" src="/img/gif.gif"></div>
        <div class="container" v-show="isShowBody" :style="styleBody">
            <a class="popup-close-button popup-color" @click="onCloseBtn">×</a>
            <div class="containerBody">
                <ul>
                    <li v-for="device in deviceList" :key="device.id" @click="addDevice($event,device.id)">
                        <div class="addDeviceImg"><img class="devImg" :src="device.devSrc"></div> 
                        <div class="addDeviceText">{{ device.devText }}</div>
                    </li>
                </ul>
            </div>
        </div>
        
    </div>
    
</template>

<script>

export default {
    name:'AddDeviceMore',
    data(){
        return {
            isShowTop:true,
            isShowBody:true,
            viewer:'',
            title:{},
            intTimer:'',
            deviceList:[{id:'device001',devSrc:'/img/Led.png',devText:'添加雾灯设备'},
                        {id:'device002',devSrc:'/img/devCam.png',devText:'添加监控设备'},
                        {id:'device003',devSrc:'/img/devQixiang.png',devText:'添加气象设备'},
                        {id:'device004',devSrc:'/img/devRadar.png',devText:'添加雷达设备'},
                        {id:'device005',devSrc:'/img/devJianCeYi.png',devText:'添加汽车检测设备'}],
            styleTop:{width:'42px',height:'42px'},
            styleBody:{width:'240px',height:'205px'},
            hostLon:'',
            hostLat:'',
        }
    },
    methods:{
        addDevice(e,id){
            console.log('AddDeviceMore组件 点击添加设备',e,id);
            this.deviceList.forEach((element)=>{
                if(element.id == id){
                    console.log('AddDeviceMore组件 点击添加设备 forEach in',element,id,this.title);
                    this.isShowBody = false ;
                    element.isShow = true ;
                    element.lon = this.hostLon ;
                    element.lat = this.hostLat ;
                    this.title = element;
                    this.$bus.emit('addDeviceInfo',this.title);
                    console.log('AddDeviceMore组件 点击添加设备 forEach in 2=',element,id,this.title);
                }
            })
        },
        mouseRightClickShow(e){
            console.log('接收到mouseRightClickCoordinate = ',e);
            clearInterval(this.intTimer);
            this.isShowTop = true ;
            this.isShowBody = true ;
            // this.styleTop.left = e.position.x-21 + 'px';
            // this.styleTop.top = e.position.y-42 +'px';
            // this.styleBody.left = e.position.x +'px';
            // this.styleBody.top = e.position.y +'px' ;
            this.hostLon = e.longitude;
            this.hostLat = e.latitude;
            let hostLon = e.longitude;
            let hostLat = e.latitude;
            // 启动定时器，当鼠标拖动地球时，该设置界面跟着雾灯一起移动
            this.intTimer = setInterval(()=>{
                            let coord = bd09_to_wgs84(hostLon ,hostLat);
                            let cartesian3 = Cesium.Cartesian3.fromDegrees(coord.longitude, coord.latitude,0);
                            let cartesian2 = Cesium.SceneTransforms.wgs84ToWindowCoordinates(this.viewer.scene,cartesian3);
                            // console.log('cartesian2 and cartesian3 = ',this.viewer.scene,cartesian2, cartesian3);
                            // this.style.left = cartesian2.x +'px'; //325
                            // this.style.top = cartesian2.y + 'px';//- 220
                            this.styleTop.left = cartesian2.x-21 + 'px';
                            this.styleTop.top = cartesian2.y-42 +'px';
                            this.styleBody.left = cartesian2.x +'px';
                            this.styleBody.top = cartesian2.y +'px' ;
                        },50);

        },
        getViewer(viewer){
            this.viewer = viewer;
        },
        onCloseBtn(){
            clearInterval(this.intTimer);
            this.isShowTop = false ;
            this.isShowBody = false;
        }
    },
    mounted() {
        this.$bus.on('mouseRightClickCoordinate',this.mouseRightClickShow);
        this.$bus.on('getViewer',this.getViewer);
    },
    unmounted(){
        this.$bus.off('getViewer');
        clearInterval(this.intTimer);
    }
}
</script>

<style scoped>
.addLogo{
    position: absolute; 
    cursor: pointer; 
    color: rgba(0, 0, 0, 0);
}
.logoImg{
    width: 42px;
    height: 42px;
    overflow: hidden;
}
.container{
    position: absolute;
    width: 240px;
    height: 205px;
    background-color:rgba(0,0,0,0.8);
    border-radius: 5px;
}
.popup-close-button {
    position: absolute;
    top: 0;
    right: 0;
    padding: 4px 4px 0 0;
    text-align: center;
    width: 18px;
    height: 14px;
    font: 16px/14px Tahoma, Verdana, sans-serif;
    text-decoration: none;
    font-weight: 700;
    background: transparent;
    z-index: 99;
  }

.popup-close-button:hover {
    cursor: pointer;
    color: red;
}
.popup-color {
    color: white;
  }

  .containerBody{
    position: absolute;
    top: 10%;
    width: 100%;
    height: 90%;
  }
 ul{
    list-style: none;
    margin: 0;
    padding: 0;
  }
li{
    height: 35px;
    line-height: 40px; 
    text-align: center;
  }
  li:hover{
    background-color: rgba(255,255,255,0.2);
  }
 .addDeviceImg{
    width: 12%; 
    height: 100%; 
    float: left; 
    margin-left: 10%;
}
.addDeviceText{
    width: 88%; 
    height: 100%; 
    color: white;
    margin-left: 10%;
}

.devImg{
    width: 20px;
    height: 20px;
    margin-top: 10px;
    margin-right: 10px;
  }
</style>